import Lexicon from './Lexicon';
import LexiconLanguage from './LexiconLanguage';

interface Props {
    isSimpleMatch: boolean;
    lexicon: Lexicon;
    language: LexiconLanguage;
    number: string;
    text: string;
}

export default class LexiconEntryMatch {

    public constructor(private readonly props: Props) {
    }

    public isSimpleMatch(): boolean {
        return this.props.isSimpleMatch;
    }

    public getLexicon(): Lexicon {
        return this.props.lexicon;
    }

    public getLanguage(): LexiconLanguage {
        return this.props.language;
    }

    public getNumber(): string {
        return this.props.number;
    }

    public getText(): string {
        return this.props.text;
    }
}
